import * as d3 from 'd3';
import c3 from 'c3';
import { debounce } from 'debounce';
import { queryChart } from './graphql/queries';
import PageLoader from './Pageloader';
import { Select, _Objects, Toggle } from './main';
import waitForFinalEvent from './WaitForEvent';
import { capitalize, toCamelCase } from './parsers';
import 'intl';
import 'intl/locale-data/jsonp/ru-RU.js';
import {
  daysOfYear, getCurrentDayOfYear, getPercent,
  getDateFromString, formatDate, formatN, formatNumObj, formatNLabel
} from './helpers';

function numToStnd(num, minDecimal = 0, maxDecimal = 2) {
  return Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: minDecimal || 0,
    maximumFractionDigits: maxDecimal || 0,
  }).format(num);
}

let axisTicks = {
  days: {
    short: [ 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс' ],
    full: [ 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье' ],
  },
  months: {
    short: [ 'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Нов', 'Дек' ],
    full: [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ],
    formatted: [ 'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря' ],
  },
  changes: {
    firstChange: 'в 1 смену',
    secondChange: 'в 2 смену',
    thirdChange: 'в 3 смену',
  },
};
let commonConfig = {
  data: {
    columns: [],
    onclick: function (d, i) {
      let $currChart = this.bindto ? $('.js-chart').filter(this.bindto) : $(this.element);
      $currChart.addClass('_hovered');
    },
    onmouseover: function (d, i) {
      let $currChart = this.bindto ? $('.js-chart').filter(this.bindto) : $(this.element);
      $currChart.addClass('_hovered');
    },
    onmouseout: function (d, i) {
      let $currChart = this.bindto ? $('.js-chart').filter(this.bindto) : $(this.element);
      $currChart.removeClass('_hovered');
    },
  },
  axis: {
    x: {
      type: 'category',
      tick: {
        centered: true,
      },
    },
    y: {
      show: false,
    },
  },
  grid: {
    x: {
      show: true,
    },
    y: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    format: {
      title: function () {
        return '';
      },
      name: function () {
        return '';
      },
    },
  },
};

function convertColors(series, colors) {
  let colorsObj = {};
  $.each(series, function (i, serie) {
    colorsObj[ serie[ 0 ] ] = colors[ i ];
  });
  return colorsObj;
}

function setChartScrollSize($chart, $data) {
  let chartType = $chart.data('chart-type');
  let box = $chart.closest('.js-chartbox');
  let wrapp = box.find('.chartbox__wrapp');
  let chart = box.find('.chartbox__chart');
  let scroll = box.find('.chartbox__scroll');

  let scrollWidth = 0;
  if (chartType === 'line' || chartType === 'area') {
    let tickCnt = $data.series[ 0 ].length - 1;
    // scrollWidth = 2.875 * tickCnt;
    scrollWidth = 3.75 * tickCnt;

    if (windowOffsets.width() >= 750) {
      scrollWidth = 4.5 * tickCnt;
    }

    chart.css({
      'width': scrollWidth + 'em',
    });
  }

  // scroll.scrollLeft(wrapp.innerWidth());
  scroll.mCustomScrollbar('update');
  scroll.mCustomScrollbar('scrollTo', wrapp.innerWidth(), {
    scrollInertia: 0,
  });
}

function setGradient($chart, $data) {
  let $chartID = $chart[ 0 ].id;
  let $chartType = $chart.data('chart-type');
  let series = $data.series;
  let gradientColors = $data.gradient;
  let gradientType = $chart.data('gradient-type') || null;

  let svg = d3.select('#' + $chartID).select('svg');
  let defs = svg.select('defs');

  function getOpacity(color) {
    let opacityArr = color.split(',');
    return (opacityArr[ 1 ] && typeof opacityArr[ 1 ] === 'string') ? parseFloat(opacityArr[ 1 ]) : 1;
  }

  $.each(series, function (i, serie) {
    let serieID = serie[ 0 ];
    let gradientID = $chartID + '_gradient' + '_' + serieID;
    let gradient = false;
    $.each(gradientColors, function (i, array) {
      if ($.inArray(serieID, array) > -1) {
        gradient = array;
        return false;
      }
    });
    if (!gradient) return true;

    let angle = gradient[ 3 ];
    let angleAttrs = (angle === 0) ? [ 0, 0, 0, 1 ] : [ 0, 1, 0, 1 ];

    let gradientSVG = defs.select('linearGradient[id="' + gradientID + '"]')
      || defs.select('redialGradient[id="' + gradientID + '"]');

    if (!gradientSVG[ 0 ][ 0 ]) {
      if (gradientType === 'radial') {
        gradientSVG = defs.append('radialGradient')
          .attr('id', gradientID)
          .attr('cx', '50%')
          .attr('cy', '50%')
          .attr('r', '50%')
          .attr('fx', '50%')
          .attr('fy', '50%');
        // .attr("spreadMethod", "repeat");
      } else {
        gradientSVG = defs.append('linearGradient')
          .attr('id', gradientID)
          .attr('x1', angleAttrs[ 0 ])
          .attr('x2', angleAttrs[ 1 ])
          .attr('y1', angleAttrs[ 2 ])
          .attr('y2', angleAttrs[ 3 ])
          .attr('spreadMethod', 'repeat');
      }

      $.each(gradient, function (i, color) {
        if (i === 0) return true;

        gradientSVG.append('stop')
          .attr('class', 'gradient_color_' + (i - 1))
          .attr('offset', Math.round(100 / (gradient.length - 2) * (i - 1)) + '%')
          .attr('stop-color', color.split(',')[ 0 ])
          .attr('stop-opacity', getOpacity(color));
      });
    }

    // setTimeout(function () {
    if ($chartType === 'area') {
      svg.select('.c3-area-' + serieID)
        .attr('style', 'fill:url(#' + gradientID + ')');
    }
    if ($chartType === 'gauge') {
      console.log('GRADIENT ' + $chartID);
      svg.select('.c3-arc-' + serieID)
        .attr('style', 'fill:url(#' + gradientID + ')');
    }
    // }, 500);
  });
}

function highlightTick($chart, index) {
  let $xAxis = $chart.find('svg g.c3-axis-x:visible');
  let $ticks = $xAxis.find('g.tick');

  $ticks.attr('active', false)
    .eq(index).attr('active', true);

}

function setMainInfo() {
  let mainInfo = $('.js-maininfo');

  if (!mainInfo || !mainInfo.length) return false;

  let infoTotal = mainInfo.find('.js-maininfo-total');
  let infoIncome = mainInfo.find('.js-maininfo-income');
  let infoOutcome = mainInfo.find('.js-maininfo-outcome');

  mainInfo.off('update').on('update', (e, data) => {
    infoTotal.text(data[ 'white' ] ? data[ 'white' ].toLocaleString('ru-RU') : '-');
    infoIncome.text(data[ 'blue' ] ? data[ 'blue' ].toLocaleString('ru-RU') : '-');
    infoOutcome.text(data[ 'red' ] ? data[ 'red' ].toLocaleString('ru-RU') : '-');
  });
}

function chartScroll($chart) {
  let chartBox = $chart.closest('.js-chartbox');
  let chartScroll = chartBox.find('.chartbox__scroll');
  let chartTooltip = chartBox.find('.chartbox__tt');
  let chartTooltipTitle = chartTooltip.find('.js-chart-tt-text');
  let chartTooltipLine = chartTooltip.find('.chartbox__tt-line');
  let lineOffsetLeft = Math.round(chartTooltipLine.offset().left);

  let rect = $chart.find('.c3-event-rect');
  let _chart = $chart.data('c3-charts');
  let chartData = _chart.data();
  let series = $.map(chartData, function (item) {
    return item.id;
  });

  function setTooltipTitle(date) {
    date = new Date(date);
    let d = date.getDate();
    let m = axisTicks.months.formatted[ date.getMonth() ];
    let y = date.getFullYear();

    chartTooltipTitle.text(d + ' ' + m + ' ' + y);
  }

  let autoScroll = false;

  function scrollToPoint(duration = 200) {
    autoScroll = true;
    let selCircle = $chart.find('svg').find('.c3-selected-circles')[ 0 ];
    let selCircleOffsets = selCircle.getBBox();

    // chartScroll.animate({
    //     'scrollLeft': selCircleOffsets.x - (selCircleOffsets.width / 2)
    // }, duration, function () {
    //     setTimeout(function () {
    //         autoScroll = false;
    //     }, 30);
    // });
    chartScroll.mCustomScrollbar('scrollTo', selCircleOffsets.x - (selCircleOffsets.width / 2), {
      scrollInertia: duration,
    });
    setTimeout(function () {
      chartScroll.mCustomScrollbar('scrollTo', selCircleOffsets.x - (selCircleOffsets.width / 2), {
        scrollInertia: 0,
      });
    }, duration);
  }

  let currIndex = 0;

  function onChartScroll() {
    $.each(rect, function (rectIndex, _rect) {
      rectIndex = (rectIndex === rect.length - 1) ? rect.length - 2 : rectIndex;
      // if (rectIndex == rect.length - 1) return false;
      let $rect = $(_rect);
      let rectOffsetLeft = Math.round($rect.offset().left);
      let rectWidth = +$rect.attr('width');

      if (lineOffsetLeft <= rectOffsetLeft + rectWidth - 2
        && lineOffsetLeft >= rectOffsetLeft + 2) {
        if (currIndex === rectIndex) return false;
        currIndex = rectIndex;

        _chart.unselect(series);
        _chart.select(series, [ currIndex ]);

        setTooltipTitle(chartData[ 0 ].values[ currIndex ].x);

        let infoData = {};
        $.each(chartData, (i, item) => {
          infoData[ item.id ] = item.values[ currIndex ].value;
        });
        $('.js-maininfo').trigger('update', [ infoData ]);
      }
    });
  }

  // let scrollEnded = true;
  // chartScroll.off('scroll');
  // chartScroll.on('scroll', function (e) {
  //     if (autoScroll) return false;
  //     onChartScroll();
  //     waitForFinalEvent(scrollToPoint, 50, $chart[0].id);
  // });

  chartScroll.off('scroller.onScroll scroller.onScrollEnd');
  chartScroll.on('scroller.onScroll', function () {
    onChartScroll();
  });
  chartScroll.on('scroller.onScrollEnd', function () {
    scrollToPoint();
  });

  onChartScroll();
  setTimeout(function () {
    scrollToPoint(0);
  }, 50, $chart[ 0 ].id);
}

function getDayOfYear(date) {
  let firstYearDate = new Date(date.getFullYear(), 0, 1);
  let diff = date.getTime() - firstYearDate.getTime();
  let dayOfYear = Math.floor(diff / (60 * 60 * 24 * 1000));
  return dayOfYear;
}

function getDaysCountInYear(year) {
  let diff = new Date(year, 11, 31) - new Date(year, 0, 0);
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

function getSeriesNames(series) {
  let seriesNames = $.map(series, function (serie) {
    return serie.id;
  });
  return seriesNames;
}

function getMaxValue(valsArray) {
  valsArray = $.map(valsArray, function (item) {
    return parseFloat(item);
  });
  return Math.max.apply(null, valsArray);
}

function setDonutClipPath($chart) {
  let $clipPathBox = $chart.parent().children('.donut-clip-path');

  let getDataArr = (arcsCount) => {
    let arr = [];
    for (let i = 0; i < arcsCount; i++) {
      arr.push({
        startAngle: (Math.PI / arcsCount) * i * 2,
        endAngle: (Math.PI / arcsCount) * (i * 2 + 1)
      });
    }

    return arr;
  };

  $clipPathBox.each((i, clipPath) => {

    const clipPathWidth = clipPath.clientWidth;
    const clipPathHeight = clipPath.clientHeight;

    const _clipPath = d3.select(clipPath);
    const svg = _clipPath
      .append("svg")
      .attr("viewBox", `0 0 ${clipPathWidth} ${clipPathHeight}`)
      .attr("width", clipPathWidth)
      .attr("height", clipPathHeight);
    const arc = d3
      .arc()
      .innerRadius(5)
      .outerRadius(15);

    const dataArr = getDataArr(50);

    const g = svg.append("g").attr("transform", "translate(15, 15)");
    const paths = g.selectAll("path").data(dataArr);
    paths
      .enter()
      .append("path")
      .attr("d", arc)
      .attr('fill', 'red');

  });
}

function initTotalChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartRole = $chart.data('chart-role');

  // $.each($data.series, function (i, serie) {
  //     $data.series[i] = serie.slice(0, 10);
  // });
  // $data.ticks[0].slice(0, 10);

  // setChartScrollSize($chart, $data);
  // setMainInfo();


  function setMainValues(mainValues) {
    let $mainVal = $chart.closest('.chart__view').find('.js-chart-mainvalue');

    if (chartID === 'total-spent-fin') {
      let $chartVal = $chart.closest('.chart__view').find('.js-chart-value._start');

      let spent = mainValues.spent || 0;
      let totalFin = mainValues.totalfin || 0;
      let percent = mainValues.percent || 0;

      $mainVal.text(numToStnd(totalFin, 0, 1));
      // $chartVal.text((spent && totalFin ? numToStnd(spent*0.1/totalFin,0,0) : 0) + '%');
      $chartVal.text(numToStnd(percent, 0, 2) + '%');
    } else if (chartID === 'total-spent-days' || chartID === 'total-subsid-days' || chartID === 'total-subjects-days') {
      let $chartValStart = $chart.closest('.chart__view').find('.js-chart-value._start');
      let $chartValEnd = $chart.closest('.chart__view').find('.js-chart-value._end');

      $chartValStart.text(mainValues.daysGone !== void(0) ? mainValues.daysGone : '-');
      $chartValEnd.text(mainValues.daysTotal !== void(0) ? mainValues.daysTotal : '-');
    } else if (chartID === 'total-subjects-ready') {
      let $chartVal = $chart.closest('.chart__view').find('.js-chart-value._start');

      let currSubjCount = mainValues.subjVal || 0;
      let totalSubjCount = mainValues.subjTotal || 0;

      $mainVal.text(currSubjCount);
      $chartVal.text((currSubjCount && totalSubjCount ? numToStnd(currSubjCount * 100 / totalSubjCount, 0, 0) : 0) + '%');

      const $units = $chart.closest('.chart__view').find('.chart__mainvalue-units');
      if (!$units || !$units.length) return false;

      let unitObjects = $units.data('units');
      $units.text(
        unitObjects instanceof Array ? formatNumObj(+currSubjCount || 0, unitObjects) : unitObjects,
      );
    }

  }

  function setToggleValues(toggleValues) {
    if (chartRole === 'total-spent') {
      $('.js-total-spent').text(toggleValues.spent !== null ? numToStnd(toggleValues.spent) : '-');
      $('.js-total-finval').text(toggleValues.totalfin !== null ? numToStnd(toggleValues.totalfin) : '-');
      $('.js-total-subsid').text(toggleValues.subsid !== null ? numToStnd(toggleValues.subsid) : '-');
    } else if (chartRole === 'total-subsid') {
      $('.js-total-subsid').text(toggleValues.totalfin !== null ? numToStnd(toggleValues.totalfin) : '-');
    } else if (chartRole === 'total-subjects') {
      $('.js-total-subjects-val').text(toggleValues.subjVal !== null ? toggleValues.subjVal : '-');
      $('.js-total-subjects-total').text(toggleValues.subjTotal !== null ? toggleValues.subjTotal : '-');
    } else if (chartRole === 'total-turns') {
      $('.js-total-turn._first').text(toggleValues.firstTurn !== null ? numToStnd(toggleValues.firstTurn, 0, 0) + '%' : '-');
      $('.js-total-turn._second').text(toggleValues.secondTurn !== null ? numToStnd(toggleValues.secondTurn, 0, 0) + '%' : '-');
      $('.js-total-turn._third').text(toggleValues.thirdTurn !== null ? numToStnd(toggleValues.thirdTurn, 0, 0) + '%' : '-');
    }
  }

  $data = { ...$data };


  let colorPattern = [ '#3357DB', '#061C69' ];
  let colorsArray = $chart.data('colors');
  $data.colors = colorsArray || colorPattern;

  let gradientPattern = [ 'x', '#3357DB', '#061C69' ];
  let gradientArray = $chart.data('gradient') || null;
  if (gradientArray && gradientArray.length) {
    $.each($data.series, function (i, serie) {
      if (gradientArray[ i ].length)
        gradientArray[ i ].unshift(serie[ 0 ]);
    });
    $data.gradient = gradientArray || gradientPattern;
  }

  let onloadEventTrigger = false;
  let inited = false;
  let _chart;
  let currentConfig = $.extend(true, {}, commonConfig, {
    bindto: '#chart_' + chartID,
    data: {
      // x: 'x',
      columns: [],
      type: chartType,
      selection: {
        enabled: true,
      },
      labels: false,
    },
    gauge: {
      // units: ' %',
      label: {
        show: false,
      },
      fullCircle: true,
      // startingAngle: 0,
      width: 20,
      max: 133.33,
      expand: false,
      // expand: true
    },
    tooltip: {
      show: false,
    },
    color: {
      pattern: [ '#061C69', '#3357DB', '#6C6B6B' ],
    },
    onrendered: function () {
      waitForFinalEvent(function () {
        if ($data.gradient) {
          console.log('RENDER ' + chartID);
          // setGradient($chart, $data);
        }
      }, 300, chartID);

    if (onloadEventTrigger) {
      // _chart.resize();
      Chart.get($chart.data('chart-id')).finishRender();
      $chart.data('c3-charts', _chart).trigger('charts.inited');
      onloadEventTrigger = false;
    }
    },
  });

  _chart = c3.generate(currentConfig);
  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.setC3(_chart);

  function updateData(data) {
    let series = data.series;
    if (!series || !series.length) return false;

    let seriesArray = [];
    $.each(series, function (i, item) {
      if (item.length < 2) item.push(null);
      seriesArray.push(item);
    });

    _chart.load({
      columns: seriesArray,
      colors: data.colors ? data.colors : '',
      done: function () {
      $chart.toggleClass('_nodata', seriesArray[ 0 ].length <= 2 && seriesArray[ 0 ][ 1 ] === null);
        onloadEventTrigger = true;
      },
    });

    if (data.mainValues) {
      setMainValues(data.mainValues);
    }
    if (data.toggleValues) {
      setToggleValues(data.toggleValues);
    }
  }

  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
}

function initBarChart($chart, $data) {
  let _chart = null;
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartRole = $chart.data('chart-role');
  let isInited = false;

  let colorPattern = [ '#061C69', '#3357DB', '#3892DD', '#45F9FF', '#7FADED', '#AAAAAA' ];
  let colorsArray = $chart.data('colors');
  if (!$data.colors) {
    $data.colors = colorsArray || colorPattern;
  }
  let onloadEventTrigger = false;

  let extTooltip = $('.js-external-tooltip[data-chart="' + chartID + '"]');

  function initExtTooltip() {
    let extTtTitle = extTooltip.find('.js-main-title');
    let extTtMainVal = extTooltip.find('.js-main-value');

    extTooltip.on('update', (e, data) => {
      if (data.value === null) {
        return false;
      }
      const divider = +extTtMainVal.data('divider');
      if (data.value && divider) {
        data.value = (+data.value / divider).toFixed(2).replace('.', ',');
      }
      if (extTtTitle) extTtTitle.text(data.title || '-');
      if (extTtMainVal) extTtMainVal.text((data.value !== void(0)) ? data.value : '-');
    });
  }

  if (extTooltip && extTooltip.length)
    initExtTooltip();

  let currentConfig = $.extend(true, {}, commonConfig, {
    bindto: '#chart_' + chartID,
    data: {
      type: 'bar',
      x: 'x',
      labels: false,
      color: $data.colors,
      // size: {
      //     height: 200
      // }
    },
    padding: {
      left: 50,
      right: 0,
      top: 5
    },
    bar: {
      width: 16,
      // space: .25
    },
    axis: {
      rotated: false,
      x: {
        show: true,
      },
      y: {
        padding: 0,
        show: true,
        tick: {
          centered: true,
          count: 5,
          format: function (d) {
            return numToStnd(d, 0, 0);
          },
        },
      },
    },
    grid: {
      x: {
        show: false,
      },
      y: {
        show: true,
      },
    },
    color: {
      pattern: colorPattern,
    },
    tooltip: {
      show: false,
      contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
        let title = $chart.data('legend') ? $chart.data('legend')[ d[ 0 ].index ] : null;
        if (title) title = (title.name) ? title.name : `${title[ 'position' ]}. ${title[ 'value' ]}`;

        let value = '',
          valueUnit = '';

        let $ttObj = $('<div class="c3-tooltip" />');
        if (title) $ttObj.append('<div class="c3-tooltip__line c3-tooltip__title"> <p>' + title + '</p> </div>');
        if (value) $ttObj.append('<div class="c3-tooltip__line c3-tooltip__value"> <p>' + `${value} ${valueUnit}` + '</p> </div>');
        return $ttObj[ 0 ].outerHTML;
      },
    },
    onrendered: function () {
      if (onloadEventTrigger) {
        Chart.get($chart.data('chart-id')).finishRender();
        $chart.data('c3-charts', _chart).trigger('charts.inited');
        onloadEventTrigger = false;
      }
    },
  });

  _chart = c3.generate(currentConfig);
  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.setC3(_chart);

  let toggleInstance;
  if (chartInstance.controls.toggles.length) {
    toggleInstance = chartInstance.controls.toggles[ 0 ];
  }

  function updateData(data) {
    let series = data.series;
    if (!series || !series.length) return false;
    const currentToggleVal = toggleInstance.getValue();

    let seriesArray = [];
    $.each(series, function (i, item) {
      if (item.length < 2) item.push(null);
      seriesArray.push(item);
    });

    if (undefined === data.ticks) {
      data.ticks = [ 'x', ...(data.ticks || $chart.data('chart-ticks') || [ null ]) ];
    }
    seriesArray.push(data.ticks);

    $data.colors = data.colors || $data.colors;
    _chart.load({
      columns: seriesArray,
      done: function () {
        $chart.toggleClass('_nodata', seriesArray[ 0 ].length <= 2 && seriesArray[ 0 ][ 1 ] === null);
        onloadEventTrigger = true;
      },
    });
    const maxVal = (currentToggleVal === 'percent') ? 100 : Math.max.apply(null, $.map(series, (serie) => {
      return Math.max.apply(null, $.map(serie.slice(1), (item) => {
        return +item;
      }));
    }));

    _chart.axis.max({ y: maxVal });
  }

  if (undefined !== toggleInstance) {
    toggleInstance.$container.off('change').on('change', function () {
      const filter = chartInstance.getFilterParams();
      const filteredData = chartInstance.convertData(chartInstance.chartData.original, filter);
      $chart.trigger('charts.updateData', filteredData);
    });
  }

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });

  updateData($data);
}

function initAreaChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartRole = $chart.data('chart-role');

  const chartInstance = Chart.get(chartID);
  let periodFilter = null, periodValue = null;

  if (chartInstance.controls.selects.length) {
    periodFilter = chartInstance.controls.selects[ 0 ];
  }

  function formatTicks(ticks) {
    if (periodFilter) {
      return ticks.map((ticksArr) => {
        return ticksArr.map((tick, i) => {
          if (i === 0) return tick;

          if (periodValue === 'month') {
            return axisTicks.months.full[ getDateFromString(tick).getMonth() ];
          } else if (periodValue === 'quarter') {
            return tick.replace(/квартал.*/gi, 'кв');
          } else if (periodValue === 'week') {
            return tick.replace(/неделя.*/gi, 'нед');
          }
        });
      });
    } else {
      return ticks.map((ticksArr) => {
        return ticksArr.map((tick, i) => {
          if (i === 0) return tick;
          return axisTicks.months.full[ getDateFromString(tick).getMonth() ];
        });
      });
    }
  }

  let onloadEventTrigger = false;

  let _chart;
  let currentConfig = $.extend(true, {}, commonConfig, {
    bindto: '#chart_' + chartID,
    padding: {
      top: 20,
      left: 35,
    },
    axis: {
      x: {
        show: true,
        padding: {
          left: -.55,
          right: -.2
        },
        tick: {
          multiline: false,
        },
      },
      y: {
        padding: 0,
        show: true,
        tick: {
          count: 5,
          format: (chartRole === 'subsid-dynamic') ? formatN : (d) => Math.round(d),
        },
      },
    },
    grid: {
      x: {
        show: false,
      },
      y: {
        show: true,
      },
    },
    tooltip: {
      contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
        let value = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(d[ 0 ].value);
        let valueUnit = ($chart.data('percent')) ? '%' : ($chart.data('values-unit') || '');

        let $ttObj = $('<div class="c3-tooltip" />');
        if (value) $ttObj.append('<div class="c3-tooltip__line c3-tooltip__value"> <p>' + `${value} ${valueUnit}` + '</p> </div>');
        return $ttObj[ 0 ].outerHTML;
      },
    },
    onrendered: function () {
      // waitForFinalEvent(function () {
      //     if ($data.gradient) {
      //         setGradient($chart, $data);
      //     }
      // }, 100, chartID);

      if (onloadEventTrigger) {
        Chart.get($chart.data('chart-id')).finishRender();
        $chart.data('c3-charts', _chart).trigger('charts.inited');
        onloadEventTrigger = false;
      }
    },
  });

  function updateData({ ...data }) {
    if (chartRole !== 'subsid-dynamic') {
      currentConfig.axis.y.max = 100;
    } else if (currentConfig.axis.y.max) {
      delete(currentConfig.axis.y.max);
    }
    let series = data.series;
    if (!series || !series.length) return false;

    if (periodFilter) {
      periodValue = periodFilter.getValue()[ 0 ].value;
    }

    let seriesArray = [];
    $.each(series, function (i, item) {
      if (item.length < 2) item.push(null);
      seriesArray.push(item);
    });

    if (!data.ticks) {
      data.ticks = axisTicks.months.full;
      let xAxisPrefix = [ 'x' ];
      data.ticks.push.apply(xAxisPrefix, data.ticks);
      data.ticks = [ xAxisPrefix ];
    }

    data.ticks = formatTicks(data.ticks);
    $.each(data.ticks, function (i, item) {
      if (item.length < 2) item.push(null);
      seriesArray.push(item);
    });

    const viewableDots = 4;

    const initialRangeLowBound = (seriesArray[0].length - viewableDots - 1 > 0) ? seriesArray[0].length - viewableDots : 0;
    const initialRangeSettings = (initialRangeLowBound === 0) ? {} : {initialRange: [initialRangeLowBound, seriesArray[0].length - 1]};

    const extendedConfig = {
      ...currentConfig, ...{
        data: {
          x: 'x',
          type: chartType,
          columns: seriesArray,
        },
        zoom: {
          enabled: true,
          ...initialRangeSettings,
        },
      },
    };
    _chart = c3.generate(extendedConfig);
    chartInstance.setC3(_chart);

    const measurement = (chartRole === 'subsid-dynamic')
      ? (formatNLabel(seriesArray[0].find((val) => !isNaN(val) && val !== 0)) || '') + ' руб.' : '%';

    _chart.axis.labels({
      y: measurement
    });
  }

  function initSelection() {
    const regionId = $chart.data('region-id');
    const filter = chartInstance.getFilterParams();
    const currentYear = _Objects.Timeline.getValue();
    periodValue = periodFilter.getValue()[ 0 ].value;
    const [ structureName, structureId ] = regionId.split('-');
    const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;
    const mapData = _Objects.MapData.getCurrentYearData();
    const neededProp = `${periodValue}Id`;
    const propSubstr = (structureName === 'fo') ? 'districts' : 'subjects';

    let currentMapElement;
    let elementData;
    let filteredData;

    const dynamicDataRef = mapData[ propSubstr + 'Data' ][ structureStr ].dynamicData;

    if (!(periodValue in dynamicDataRef)) {
      currentMapElement = mapData[ propSubstr ].find(({ name }) => name === structureStr);
    } else {
      elementData = dynamicDataRef[ periodValue ];
    }

    if (undefined === elementData) {
      const queryParams = {
        id: currentMapElement[ neededProp ],
        year: '' + currentYear,
      };
      chartInstance.loader.show(true);
      queryChart(queryParams).then(({ data }) => {
        dynamicDataRef[ periodValue ] = data.chart[ 0 ].axisX;
        elementData = dynamicDataRef[ periodValue ];
        filteredData = chartInstance.convertData(chartInstance.chartData.original, filter);
        chartInstance.loader.hide();
        $chart.trigger('charts.updateData', filteredData);
      });
    } else {
      filteredData = chartInstance.convertData(chartInstance.chartData.original, filter);
      $chart.trigger('charts.updateData', filteredData);
    }
  }


  if (periodFilter) {
    periodFilter.$container.off('change').on('change', function () {
      initSelection();
    });
  }
  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
  chartInstance.inited = true;
}

function initDonutChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartRole = $chart.data('chart-role');
  const chartSubtype = $chart.data('chart-subtype');
  let isDashed = $chart.is('.chart_dashed');

  let colorPattern = [ '#3357DB', '#061C69' ];
  let colorsArray = $chart.data('colors');
  $data.colors = colorsArray || colorPattern;
  let onloadEventTrigger = false;

  let _chart;
  const $mainValue = $chart.closest('.js-chartbox').find('.js-chart-mainvalue');

  let chartBorderWidth = 20;
  if (chartRole === 'region-chart' || chartRole === 'completion-chart')
    chartBorderWidth = 3;

  let currentConfig = $.extend(true, {}, commonConfig, {
    bindto: '#chart_' + chartID,
    data: {
      columns: [],
      type: chartType,
      order: null,
    },
    donut: {
      width: chartBorderWidth,
      label: {
        show: false,
      },
      expand: false,
    },
    padding: {
      left: 0,
    },
    tooltip: {
      show: false,
    },
    onrendered: function () {
      waitForFinalEvent(function () {
        // if ($data.gradient)
        //   setGradient($chart, $data);

        // setDonutClipPath($chart);
      }, 100, chartID);

      if (onloadEventTrigger) {
        Chart.get($chart.data('chart-id')).finishRender();
        $chart.data('c3-charts', _chart).trigger('charts.inited');
        onloadEventTrigger = false;
      }
    },
  });
  _chart = c3.generate(currentConfig);
  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.setC3(_chart);

  function updateData(data) {
    const series = data.series;
    if (!series || !series.length) return false;
    if (chartRole === 'region-total' || chartRole === 'completion-chart' || chartRole === 'region-chart') {
      _chart = c3.generate(currentConfig);
      chartInstance.setC3(_chart);
    }

    const [firstNonEmptyIndex, ...otherNonEmptyIndices] = series.reduce((acc, [name, value], index) =>
      (value !== 0) ? acc.concat(index) : acc, []);
    const seriesArray = (otherNonEmptyIndices.length) ? series.map((item) => (item.length < 2) ? [...item, null] : item)
      : [series[firstNonEmptyIndex]];
    const colors = (otherNonEmptyIndices.length) ? convertColors(series, $data.colors || data.colors)
      : {[seriesArray[0][0]]: $data.colors[firstNonEmptyIndex]};

    _chart.load({
      columns: seriesArray,
      colors: colors,
      done: function () {
        $chart.toggleClass('_nodata', seriesArray[ 0 ].length <= 2 && seriesArray[ 0 ][ 1 ] === null);
        onloadEventTrigger = true;
      },
    });

    if (chartID.indexOf('region-total') > -1) {
      let $container = _Objects.RegionMap.RightPanel.$container;
      if (chartID.indexOf('report-region-total') > -1) {
        $container = _Objects.Reports.$graphicReportNote.find('.js-chart#chart_' + chartID).closest('.reports-total__chart');
      }
      const budget = data.budgetValues;
      $container.find('.js-region-charts-total__mainval').text(+budget.total ? numToStnd(+budget.total, 0, 0) : '-');
      $container.find('.js-region-charts-total__subval._fo').text(budget.federalBudget || '-');
      $container.find('.js-region-charts-total__subval._subject').text(budget.subjectBudget || '-');
    }

    if (chartID === 'schools-total') {
      const percent = data.percent;
      $mainValue.text(percent);
    }
  }

  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
}

function initDonutCustomChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartRole = $chart.data('chart-role');
  const chartSubtype = $chart.data('chart-subtype');
  const chartSegmented = chartSubtype === 'segmented';

  let colorPattern = [ '#3357DB', '#061C69' ];
  let colorsArray = $chart.data('colors');
  $data.colors = colorsArray || colorPattern;
  let onloadEventTrigger = false;

  let _chart;
  const $mainValue = $chart.closest('.js-chartbox').find('.js-chart-mainvalue');

  let chartBorderWidth = 20;
  if (chartRole === 'region-chart' || chartRole === 'completion-chart')
    chartBorderWidth = 3;

  const onRender = () => {
    if (onloadEventTrigger) {
      Chart.get($chart.data('chart-id')).finishRender();
      $chart.data('c3-charts', _chart).trigger('charts.inited');
      onloadEventTrigger = false;
    }
  };

  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.setC3({
    resize: () => { }
  });

  function updateData(data) {
    const series = data.series;
    if (!series || !series.length) return false;

    const [firstNonEmptyIndex, ...otherNonEmptyIndices] = series
      .map((t, i) => ({ name: t[0], value: t[1], index: i}))
      .filter(t => t.value !== 0)
      .map(t => t.index);

    if (firstNonEmptyIndex === undefined) return false;

    const seriesArray = (otherNonEmptyIndices.length)
      ? series.map((item) => (item.length < 2) ? [...item, null] : item)
      : [series[firstNonEmptyIndex]];

    const colors = (otherNonEmptyIndices.length)
      ? ($data.colors || data.colors)
      : [$data.colors[firstNonEmptyIndex]];

    // Обновление DOM-элементов графика

    // Размер графика в единицах svg (он растягивается под контейнер)
    const svgSize = 40;

    // Считает углы для сегментов пончика
    const pie = d3.pie()
      .sort(null)
      .value((d) => d[1]);

    // Превращает углы в атрибут d для path
    const arc = d3.arc()
      .outerRadius(svgSize/2)
      .innerRadius(svgSize/2 * 0.85);

    // Цвет i-того сегмента
    const getColor = (d, i) => colors[i];

    // Создаем svg, если еще нет
    $chart = $(`#chart_${chartID}`); // При перестроении карточек объектов на правой панельке применяется .empty()
    let $svg = $chart.find('svg');
    if ($svg.length === 0) {
      $svg = $(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${svgSize} ${svgSize}" preserveAspectRatio="xMidYMid meet" class="donut-custom" />`);
      $svg.appendTo($chart);
    }
    const d3svg = d3.select($svg.get(0));

    // Считаем углы по данным
    const slices = pie(seriesArray);

    // Создаем g, если еще нет
    let gPath = d3svg.selectAll('g').data([1]);
    let gPathEnter = gPath.enter().append('g').classed('_segmented', chartSegmented);
    let gPathMerge = gPathEnter.merge(gPath);

    // Центрируем
    gPathMerge.attr('transform', `translate(${svgSize/2}, ${svgSize/2})`);

    if (chartSegmented) {
      const numSegments = 180;
      const step = Math.PI * 2 / numSegments / 2;
      const halfStep = step/2;
      const segmentedData = [];
      for (let i = 0; i < numSegments; i++) {
        const start = step * i * 2 + halfStep;
        const end = step * (i * 2 + 1) + halfStep;
        let segmentSlice = null;
        for (let j = 0; j < slices.length; j++) {
          const slice = slices[j];
          if (slice.startAngle < start && slice.endAngle > start) {
            segmentSlice = slice;
            break;
          }
        }
        if (segmentSlice !== null) {
          segmentedData.push({
            data: segmentSlice.data,
            padAngle: 0,
            index: segmentSlice.index,
            startAngle: start,
            endAngle: end
          });
        }
      }
      const nodes = gPathMerge.selectAll('path.arc').data(segmentedData);
      const nodesEnter = nodes.enter().append('path').attr('class', 'arc');
      nodes.exit().remove();
      nodes.merge(nodesEnter).attr('d', arc).style('fill', (d, i) => getColor(d, d.index));
    } else {
      // Добавляем или модифицируем сегменты
      const nodes = gPathMerge.selectAll('path.arc').data(slices);
      const nodesEnter = nodes.enter().append('path').attr('class', 'arc');
      nodes.exit().remove();
      nodes.merge(nodesEnter).attr('d', arc).style('fill', getColor);
    }

    // DOM обновлен

    if (chartID.indexOf('region-total') > -1) {
      let $container = _Objects.RegionMap.RightPanel.$container;
      if (chartID.indexOf('report-region-total') > -1) {
        $container = _Objects.Reports.$graphicReportNote.find('.js-chart#chart_' + chartID).closest('.reports-total__chart');
      }
      const budget = data.budgetValues;
      $container.find('.js-region-charts-total__mainval').text(+budget.total ? numToStnd(+budget.total, 0, 0) : '-');
      $container.find('.js-region-charts-total__subval._fo').text(budget.federalBudget || '-');
      $container.find('.js-region-charts-total__subval._subject').text(budget.subjectBudget || '-');
    }

    if (chartID === 'schools-total') {
      const percent = data.percent;
      $mainValue.text(percent);
    }

    $chart.toggleClass('_nodata', seriesArray[ 0 ].length <= 2 && seriesArray[ 0 ][ 1 ] === null);
    onloadEventTrigger = true;

    onRender();
  }

  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
}

function initTextChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartSubType = $chart.data('chart-subtype');
  let chartRole = $chart.data('chart-role');

  function setMainValue(value) {
    let $mainVal = $chart.find('.js-chart-mainvalue');

    if (chartSubType === 'date') {
      $mainVal.text(value ? formatDate(getDateFromString(value)) : '-');
    } else {
      $mainVal.text(value ? numToStnd(+value, 0, 0) : '-');
    }

    let $units = $chart.find('.chart__mainvalue-units');
    if (!$units || !$units.length) return false;

    let unitObjects = $units.data('units');
    $units.text(
      unitObjects instanceof Array ? formatNumObj(+value || 0, unitObjects) : unitObjects,
    );
  }

  const setValue = (value) => {
    const $val = $chart.find('.js-chart-value__mainval');
    $val.text(numToStnd(+value, 0, 0));
  };

  function updateData(data) {
    if (chartID === 'region-gov-subs' || chartID === 'pupils-count') {
      setValue(data.mainValue);
    } else {
      setMainValue(data.mainValue);
    }
    $chart.trigger('charts.inited');
  }
  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.inited = true;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
}

function initProgressChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartSubType = $chart.data('chart-subtype');
  let chartRole = $chart.data('chart-role');

  let $chartBox = $('.js-chartbox[data-chartbox-id="' + chartID + '"]');
  let $progressBar = $chart.find('.js-progress-bar__bar');
  const $progressBarComparison = $chart.find('.progress-bar._comparison');
  let $mainVal = $chartBox.find('.js-chart-value__mainval');
  let $subVals = $chartBox.find('.js-chart__values-progress .chart__value');
  let $subValCurrent = $subVals.filter('._current');
  let $subValTotal = $subVals.filter('._total');

  function setValues(data) {
    if ($subValCurrent.length) $subValCurrent.text(data.fact);
    if ($subValTotal.length) $subValTotal.text(data.plan);
  }

  function updateData(data) {
    if (data.percent > 100) {
      data.percent = 100;
    }
    if (isNaN(data.percent)) {
      $progressBarComparison.css('background', '#EBECED');
      $progressBar.css('background', '#EBECED');
    } else {
      $progressBarComparison.css('background', '');
      $progressBar.css('background', '');
      $progressBar.css('width', data.percent + '%');
    }
    setValues(data);
    $chart.trigger('charts.inited');
  }
  const chartInstance = Chart.get($chart.data('chart-id'));
  chartInstance.inited = true;
  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
}

function initReadyDatesChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartSubType = $chart.data('chart-subtype');
  let chartRole = $chart.data('chart-role');

  let $dateFirst = $chart.find('.js-ready-dates-value._first');
  let $dateLast = $chart.find('.js-ready-dates-value._last');

  function setDates(dates = {}) {
    if (chartID.indexOf('report-object-ready-dates') > -1) {
      const $container = _Objects.Reports.$graphicReportNote.find('.js-chart#chart_' + chartID).closest('.ready-dates__chart');
      $dateFirst = $container.find('.js-ready-dates-value._first');
      $dateLast = $container.find('.js-ready-dates-value._last');
    }
    if ($dateFirst.length && dates.first) {
      $dateFirst.text(formatDate(getDateFromString(dates.first)));
    } else if (!dates.first.length) {
      $dateFirst.closest('.ready-dates__dot-value').addClass('_hidden');
    }
    if ($dateLast.length && dates.last) {
      $dateLast.text(formatDate(getDateFromString(dates.last)));
    } else if (!dates.last.length) {
      $dateLast.closest('.ready-dates__dot-value').addClass('_hidden');
    }
  }

  function updateData(data) {
    setDates(data);
    $chart.trigger('charts.inited');
  }

  const chartInstance = Chart.get(chartID);
  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
  chartInstance.inited = true;
}

function initOverviewDataChart($chart, $data) {
  let chartID = $chart.data('chart-id');
  let chartType = $chart.data('chart-type');
  let chartSubType = $chart.data('chart-subtype');
  let chartRole = $chart.data('chart-role');

  const $teacher = $chart.find('.js-teacher-value');
  const $schools = $chart.find('.js-schools-value');
  const $sports = $chart.find('.js-sports-value');
  const $emergency = $chart.find('.js-emergency-value');
  let $capacity = $chart.find('.js-capacity-value');
  let $equip = $chart.find('.js-equip-value');

  function setData(data = {}) {
    if (chartID.indexOf('report-overview-data') > -1) {
      const $container = _Objects.Reports.$graphicReportNote.find('.js-chart#chart_' + chartID).closest('.reports-total__info');
      $capacity = $container.find('.js-capacity-value');
      $equip = $container.find('.js-equip-value');
    }
    if ($teacher.length) {
      $teacher.text(data.teacher);
      const $measurement = $teacher.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.teacher || 0, unitObjects) : unitObjects,
      );
    }
    if ($schools.length) {
      $schools.text(data.schools);
      const $measurement = $schools.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.schools || 0, unitObjects) : unitObjects,
      );
    }
    if ($sports.length) {
      $sports.text(data.sports);
      const $measurement = $sports.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.sports || 0, unitObjects) : unitObjects,
      );
    }
    if ($emergency.length) {
      $emergency.text(data.emergency);
      const $measurement = $emergency.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.emergency || 0, unitObjects) : unitObjects,
      );
    }
    if ($capacity.length) {
      $capacity.text(data.capacity);
      const $measurement = $capacity.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.capacity || 0, unitObjects) : unitObjects,
      );
    }
    if ($equip.length) {
      $equip.text(data.equip);
      const $measurement = $equip.parent().find('.chart__info-item__measurement');
      if (!$measurement || !$measurement.length) return false;

      let unitObjects = $measurement.data('units');
      $measurement.text(
        unitObjects instanceof Array ? formatNumObj(+data.equip || 0, unitObjects) : unitObjects,
      );
    }
  }

  function updateData(data) {
    setData(data);
    $chart.trigger('charts.inited');
  }

  const chartInstance = Chart.get(chartID);
  chartInstance.updateCb = updateData;

  $chart.on('charts.updateData', function (e, data) {
    updateData(data);
  });
  updateData($data);
  chartInstance.inited = true;
}

export function bindCharts($charts) {
  $charts.off('charts.init').on('charts.init', function (e, data) {
    let $chart = $(this);
    let chartRole = $chart.data('chart-role');
    let chartType = $chart.data('chart-type');
    if (!data) {
      return;
    }

    if ($chart.data('is-initializing')) return;
    $chart.data('is-initializing', true);

    if (chartRole === 'total-spent'
      || chartRole === 'total-subjects'
      || chartRole === 'total-turns') {
      initTotalChart($chart, data);
      return false;
    }

    if (chartType === 'area') {
      initAreaChart($chart, data);
    } else if (chartType === 'bar') {
      initBarChart($chart, data);
    } else if ((chartType === 'donut') || (chartType === 'gauge')) {
      initDonutChart($chart, data);
    } else if (chartType === 'donutCustom') {
      initDonutCustomChart($chart, data);
    } else if ((chartType === 'progressBar')) {
      initProgressChart($chart, data);
    } else if ((chartType === 'readyDates')) {
      initReadyDatesChart($chart, data);
    } else if (chartType === 'text') {
      initTextChart($chart, data);
    } else if ((chartType === 'overviewData')) {
      initOverviewDataChart($chart, data);
    }
  });

  $charts.off('charts.resize').on('charts.resize', debounce(() => {

    let _chart = $(this).data('c3-charts');
    if (_chart && _chart.hasClass('._inited')) _chart.resize();
  }, 100));

}

export function charts(mainStructureId) {
  let chart = $('.js-chart');
  if (!chart || !chart.length) return false;

  /**
   * Инициализация графиков
   */
  bindCharts(chart);
  $(window).on('resize', function () {
    debounce(() => {
      $('.js-chart._inited:visible').each(function () {
        $(this).trigger('charts.resize');
      });
    }, 50);
  });


  function initAllCharts() {

    let $charts = chart.not('._inited');

    $charts.each(function (index, chart) {

      if (!$(chart).data('indicators')) return true;

      if (!Chart.get($(chart).data('chart-id'))) {
        Chart.make($(chart).data('chart-id'));
      }
    });

  }

  function showCharts($chart) {
    if (!$chart) return false;
    $chart.each(function (i, chart) {
      let _chart = Chart.get($(chart).data('chart-id'));
      if (_chart) _chart.show();
      // Chart.get($(chart).data('chart-id')).show();
    });
    PageLoader.getInstance().hide('charts');
  }

  function getPageRelCharts(pageData, $charts, exactPosition) {
    if (exactPosition && (!$charts || !$charts.length)) return null;
    $charts = $charts || $('.js-chart:not(.report-chart):visible');
    // $charts.add('.js-chart[data-page-relation-disabled=true]');
    return $charts.filter(function (i, chart) {
      let $currChart = $(chart);
      let chartPageRel = $currChart.data('page-relative') || null;

      return chartPageRel && chartPageRel === pageData;
    });
  }


  Chart.getMainData(mainStructureId).then(() => {

    _Objects.isLoading = false;

    initAllCharts();
    let $chart = getPageRelCharts(_Objects.pageData).add('.js-chart[data-page-relation-disabled=true]');
    showCharts($chart);
  });

  /**
   * on Page-type changed
   */
  _Objects.Page.$container.on('pageSet', function (e, pageData) {
    let $chart = getPageRelCharts(pageData);
    setTimeout(function () {
      showCharts($chart);
    }, 500);
  });

  /**
   * on Total changed
   */
  _Objects.Total.$container.on('changed', function (e, type) {
    let $chart = _Objects.Total.$chart.filter('._active').find('.js-chart');
    // showCharts($chart);
    $chart.trigger('charts.resize');
  });

  /**
   * on Period changed
   */
  _Objects.Filters.Period.$container.on('changed', function () {
    let $charts = $('.js-chart:not(.report-chart)');
    setTimeout(() => {
      $charts.each((i, chart) => {
        const chartObject = Chart.get($(chart).data('chart-id'));
        if (chartObject != undefined) {
          chartObject.initChartData();
          chartObject.show();
        }
      });
    }, 200);
  });

  /**
   * on Timeline changed
   */
  _Objects.Timeline.$container.on('changed', function () {
    let $charts = $('.js-chart:not(.report-chart)');
    $charts.each((i, chart) => {
      const chartObject = Chart.get($(chart).data('chart-id'));
      if (chartObject != undefined) {
        chartObject.initChartData();
        chartObject.show();
      }
    });
  });

  /**
   * on any tab changed
   * find and show $chart from active tab
   * ТОРМОЗА
   */
  /*let $tabBox = $('.tab-box'); Лишь затормаживает переключения на странице отчетов
  $tabBox.on('tabs.changed', function (e, $activeTab) {
    //let $chart = getPageRelCharts(_Objects.pageData, $activeTab.find('.js-chart:visible'), true);
    //showCharts($chart);
  });*/
}

let mainData = [];

let chartsArray = {};

export class Chart {

  static getMainData(mainStructureId) {
    return queryChart({ id: mainStructureId }).then(({ data: { chart } }) => {
      const { axisX } = chart[ 0 ];
      _Objects.MainStructure[ 'TYPE_MAIN' ][ 'chartsData' ] = axisX.slice();
    });
  }

  static get(id) {
    // if (chartsArray[id]) chartsArray[id].$chart = $('.js-chart[data-chart-id="'+id+'"]');
    return chartsArray[ id ] || null;
  }

  /**
   * Фабрика графиков
   * @param id
   * @return {*}
   */
  static make(id) {
    let $chart = $('.js-chart[data-chart-id="' + id + '"]');
    let chartType = $chart.data('chart-type');

    switch (chartType) {

      case 'donut':
        new ChartDonut(id);
        break;
      case 'gauge':
        new ChartGauge(id);
        break;
      case 'area':
        new ChartArea(id);
        break;
      case 'bar':
        new ChartBar(id);
        break;
      case 'progressBar':
        new ChartProgress(id);
        break;
      case 'donutCustom':
        new ChartDonutCustom(id);
        break;
      default:
        new Chart(id);
        break;
    }
    return chartsArray[ id ];
  }

  static filterIndicators(queryParams, chart) {

    let chartStructureType = chart.mainStructType;
    if (!chartStructureType) {
      throw new Error('Графику не назначена принадлежность странице (или назначена неверно)');
    }

    let queryIndicators = queryParams.indicators;
    let queryYear = queryParams.timeline;

    /**
     * есть ли объект с данными (был ли запрос данных на эту часть структуры)
     */
    let currData = _Objects.MainStructure[ chartStructureType ].chartsData;
    if (!currData) return false;

    /**
     * есть ли объект с данными для нужного года (queryYear)
     */
    let currDataObject = currData.filter(({ name }) => +name === queryYear);
    if (!currDataObject.length) return null;
    let currDataArray = currDataObject[ 0 ].axisY.slice();

    if (!queryIndicators || !queryIndicators.toString().length) return null;
    if (queryIndicators === 'days') return queryIndicators;

    let data = null;
    const substrToCut = 'Столбец';

    if (typeof queryIndicators === 'number') {
      data = currDataArray.find(({ name }) => {
        const id = name.replace(substrToCut, '');
        return queryIndicators.toString() === id;
      });
    } else {
      const indicArray = queryIndicators.split(',');
      data = currDataArray.filter(({ name }) => {
        const id = name.replace(substrToCut, '');
        return indicArray.includes(id);
      }) || null;
    }

    return data || null;
  }

  constructor(id) {
    let _this = this;

    _this.id = id;
    _this.$chart = $('.js-chart[data-chart-id="' + id + '"]');
    _this.$chartBox = $('.js-chartbox[data-chartbox-id="' + id + '"]');
    _this.chartFullId = _this.$chart.data('chart-full-id');
    _this.chartType = _this.$chart.data('chart-type');
    _this.chartSubtype = _this.$chart.data('chart-subtype') || null;
    _this.chartRole = _this.$chart.data('chart-role');
    _this.indicators = _this.$chart.data('indicators');
    _this.filterIndicators = _this.$chart.data('filter-indicators') || null;
    _this.valuesDivider = ',';
    _this.decimalFixed = 2;

    _this.pageRelation = _this.$chart.data('page-relative') || null;
    switch (_this.pageRelation) {
      case 'indicators':
        _this.mainStructType = 'TYPE_MAIN';
        break;
      case 'build-progress':
        _this.mainStructType = 'TYPE_COUNTRY';
        break;
      case 'reports':
        _this.mainStructType = 'TYPE_TEXT_REPORT';
        break;
      default:
        _this.mainStructType = null;
    }

    let selects = [];
    $('.js-chart-filter.js-select[data-select-id="' + id + '"]').each(function () {
      selects.push(new ChartSelect(id));
    });

    let toggles = [];
    $('.js-chart-filter.js-toggle[data-toggle-id="' + id + '"]').each(function () {
      toggles.push(new ChartToggle(id));
    });

    let timelines = [];
    $('.js-chart-filter.js-timeline[data-timeline-id="' + id + '"]').each(function () {
      toggles.push(new ChartTimeline(id));
    });

    _this.controls = {
      selects, toggles, timelines,
    };

    _this.loader = new ChartLoader(_this, _this.$chartBox);
    _this.updateBlockTimer = null;
    _this.triggerFinishLoad = null;

    if (!_this.chartData) {
      _this.initChartData();
    }
    _this.saveChart();
  }

  initChartData() {
    const _this = this;
    const reportsIds = [ 'region-total', 'overview-data', 'build-dynamic',
      'object-ready-dates', 'object-overview-data', 'region-gov-subs' ];
    const reportFinded = reportsIds.filter((id) => _this.id.indexOf(id) > -1);

    const id = (reportFinded.length) ? reportFinded[ 0 ] : _this.id;

    let queryParams = _this.getQueryParamsChart();
    let data = null;

    function getDataFromMap(dataType) {
      const regionId = _this.$chart.data('region-id');
      const mapData = _Objects.MapData;
      const [ structureName, structureId ] = regionId.split('-');
      const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;
      let propName;
      switch (structureName) {
        case 'fo':
          propName = 'districtsData';
          break;
        case 'subj':
          propName = 'subjectsData';
          break;
        default:
          propName = 'objectsData';
          break;
      }
      if (!mapData.hasData()) {
        return null;
      }
      const dataRef = mapData.getCurrentYearData()[ propName ];
      if (!dataRef || !dataRef[ structureStr ]) {
        return null;
      }
      return (dataType === 'dynamicData') ? dataRef[ structureStr ] : dataRef[ structureStr ][ dataType ];
    }

    let staticMapDataChartIdx = [
      'region-total',
      'object-ready-dates',
      'objects-built',
      'region-gov-subs',
      'overview-data',
      'object-overview-data',
      'pupils-count',
      'stud-count',
      'schools-total',
      'ready-dates',
    ];
    let dynamicMapDataChartIdx = [
      'region-subsid',
      'build-dynamic',
    ];

    if (staticMapDataChartIdx.indexOf(id) > -1) {
      data = getDataFromMap('staticData');
    } else if (dynamicMapDataChartIdx.indexOf(id) > -1) {
      data = getDataFromMap('dynamicData');
    } else if (_this.chartRole === 'region-chart' || _this.chartRole === 'completion-chart') {
      data = _this.$chart.data('chartData');
    } else {
      data = Chart.filterIndicators(queryParams, _this);
    }

    if (data === false) {
      _this.init();
      return;
    }
    if (data === null) {
    }

    _this.saveReceivedData(data, queryParams);

  }

  init() {
    let _this = this;
    _this.loader.show();
    _this.inited = false;
    // let promise = this.initControls().then(results => {
    //     _this.updateChart();
    // }).catch(error => {
    //     _this.finishLoad();
    // });
    _this.updateChart();

    return _this;
  }

  initControls() {
    let _this = this;
    let promises = [];

    if (_this.controls.selects.length) {
      // this.controls.selectors.forEach(function(select) {
      //     promises.push(select.init());
      // });
    }

    if (_this.controls.timelines.length) {
      // promises.push(this.getDataForYearChooser().then(data => {
      //     return queryAvailbleYears({
      //         idIndicator: data.idIndicator.length ? data.idIndicator : _this.controls.timeLines[0].$timeline.data('indicator'),
      //         idOrganisation: data.idOrganisation
      //     }).then(data => {
      //         this.initControlYears(data);
      //     });
      // }));
    }

    return Promise.all(promises);
  }

  render() {
    let _this = this;

    if (!_this.chartData) {
      _this.waitData = true;
      return false;
    }

    if (_this.inited && _this.updateCb) {
      const callback = _this.updateCb;
      _this.$chart.off('charts.updateData').on('charts.updateData', function (e, data) {
        callback(data);
      });
    }
    //console.log(this.id, this.inited, this.chartData.chart[0]);

    if (!_this.inited && _this.chartData.chart[ 0 ]) {
      _this.$chart.trigger('charts.init', _this.chartData.chart);
    } else if (!_this.chartData.chart[ 0 ]) {
      if (_this.pageRelation === 'reports') {
        $('.js-region-charts-item.reports-item').filter(function () {
          return $(this).find(`.js-chart[data-chart-id=${_this.id}]`).length === 1;
        }).addClass('_hidden');
      } else {
        _this.$chart.closest('.js-region-charts-item').addClass('_hidden');
      }
    } else {
      _this.$chart.closest('.js-region-charts-item').removeClass('_hidden');
      _this.$chart.trigger('charts.updateData', _this.chartData.chart);
    }
    return this;
  }

  finishRender() {
    // на iOs график после init не отображается. Для этого дополнительно вызываем resize.
    let _this = this;
    if (!_this.inited) {
      _this.inited = true;
      this.chartC3.resize();
    }
    return this;
  }

  finishLoad() {
    let _this = this;
    _this.$chart.trigger('finishLoad');
    if (_this.triggerFinishLoad) {
      _this.triggerFinishLoad.forEach(function (callback) {
        callback(_this);
      });
    }
  }

  updateChart() {
    let _this = this;
    _this.loader.show(true);

    // clearTimeout(_this.updateBlockTimer);
    // _this.updateBlockTimer = setTimeout(function () {
    //
    let queryParams = _this.getQueryParamsChart();

    _this.getChartData(queryParams).then(data => {
      _this.saveReceivedData(data, queryParams);
      if (_this.inited || _this.waitData) {
        _this.waitData = false;
        _this.show();
      }
      _this.finishLoad();
    }).catch(error => {
      _this.finishLoad();
    });

    // }, 100);
  }

  setC3(c3Object) {
    this.chartC3 = c3Object;
    return this;
  }

  convertData(data, filter) {
    let _this = this;
    let converter = new Converter(data);
    let methodName = '';
    if (!_this.id) {
      return;
    }

    if (_this.indicators === 'days') {
      methodName = 'toDays';
    } else {
      methodName = 'to' + capitalize(toCamelCase(_this.id));
      if (_this.chartFullId) {
        if (typeof converter[ methodName ] === 'undefined') {
          methodName = 'to' + capitalize(toCamelCase(_this.chartFullId));
        }
      }
      if (typeof converter[ methodName ] === 'undefined') {
        methodName = 'to' + capitalize(toCamelCase(_this.chartType));
      }
      if (typeof converter[ methodName ] === 'undefined') {
        methodName = 'to' + capitalize(toCamelCase(_this.chartRole));
      }
    }

    return [ converter[ methodName ](filter) ];
  }

  getChartData(params) {
    return queryChart(params);
  }

  getQueryParamsChart() {
    let _this = this;

    let queryParams = {
      // idOrgBuh : User.findFromLS().getOrgBuhCode(),
      indicators: _this.indicators,
      // valuesDivider: _this.valuesDivider,
      // decimalFixed: _this.decimalFixed
    };

    let filterParams = _this.getFilterParams();
    // queryParams = Object.assign(queryParams, filterParams);
    queryParams = { ...queryParams, ...filterParams };

    // queryParams.sampleType = this.chart.data('sample') || 'year';

    // if (queryParams.toggle && (typeof queryParams.toggle.dimension !== "undefined")) {
    //     queryParams.dimension = queryParams.toggle.dimension;
    // }
    // if (queryParams.timeline) {
    //     queryParams.datePeriod = queryParams.timeline;
    // }
    //
    // delete queryParams.select;

    return queryParams;
  }

  getFilterParams() {
    let _this = this;
    let params = {};

    /**
     * indicators by period
     */
    let indicatorsToFilter = null;
    if (undefined !== _this.$chart.data('region-id')) {
      params.type = _this.$chart.data('region-id').split('-')[ 0 ];
    }
    const type = params.type;
    params.period = _Objects.Filters.Period.getValue()[ 0 ].value;
    if (_this.filterIndicators) {
      if (_this.filterIndicators[ 'type' ]) {
        indicatorsToFilter = _this.filterIndicators[ 'type' ][ type ][ 'period' ][ params.period ];
        indicatorsToFilter = +indicatorsToFilter ? +indicatorsToFilter : indicatorsToFilter;
      }
      if (_this.filterIndicators[ 'period' ]) {
        indicatorsToFilter = _this.filterIndicators[ 'period' ][ params.period ];
        indicatorsToFilter = +indicatorsToFilter ? +indicatorsToFilter : indicatorsToFilter;
      }
    }

    params.indicators = indicatorsToFilter || _this.indicators;

    /**
     * timeline
     */
    params.timeline = +_Objects.Timeline.getValue();

    /**
     * toggle
     */
    params.toggles = _this.controls.toggles.map((toggle) => {
      return toggle.getValue();
    });

    params.selects = _this.controls.selects.map((select) => {
      return select.getValue();
    });

    return params;
  }

  show() {
    this.render();
    this.loader.hide();
  }

  hide() {
    this.$chartBox.hide();
  }

  noDataHandle() {
    let _this = this;
    let $chart = _this.$chart;

    $chart.addClass('_nodata');
  }

  saveChart() {
    chartsArray[ this.id ] = this;
    return this;
  }

  saveReceivedData(data, queryParams) {
    this.chartData = {
      chart: this.convertData(data, queryParams),
      original: data,
    };
  }

  onFinishLoad(callback) {
    let _this = this;
    if (!_this.triggerFinishLoad) {
      _this.triggerFinishLoad = [];
    }
    _this.triggerFinishLoad.push(callback);
  }
}

class ChartMain extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartDonut extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartDonutCustom extends Chart {

}

class ChartGauge extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartArea extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartBar extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartProgress extends Chart {

  constructor(id) {
    super(id);
  }

}

class ChartSelect {
  constructor(id) {
    // let _this = this;

    return Select.get(id) || new Select($('.js-select[data-select-id="' + id + '"]')[ 0 ]);
  }

  static get(id) {
    return Select.get(id);
  }
}

class ChartToggle {
  constructor(id) {
    // let _this = this;

    return Toggle.get(id) || new Toggle($('.js-toggle[data-toggle-id="' + id + '"]')[ 0 ]);
  }

  static get(id) {
    return Toggle.get(id);
  }
}

class ChartTimeline {
  constructor(id) {
    // let _this = this;

    return Timeline.get(id) || new Timeline($('.js-timeline[data-timeline-id="' + id + '"]')[ 0 ]);
  }
}

class ChartLoader {

  constructor(chart, $chartBox) {
    this.chart = chart;
    this.$chartBox = $chartBox;
  }

  show(isLoading) {
    this.$chartBox.addClass(isLoading ? '_loading' : '_initing');
  }

  hide() {
    this.$chartBox.removeClass('_initing _loading').addClass('_inited');
  }

}


class Converter {
  static getSeries(object, axisName) {
    axisName = axisName || 'x';
    return [ axisName, ...(object instanceof Array ? object : [ object ]) ];
  }

  constructor(data) {
    this.initialData = data;
  }

  getData(id) {
    return this.initialData ? this.initialData.find(({ name }) => name === id) : null;
  }

  toTotalSpentFin(filter) {
    let period = filter.period;
    const additionalStr = 'Столбец';
    const filterIds = {
      'current': {
        percent: 26,
        toggleSpent: 27,
        toggleTotal: 25,
        mainTotal: 252,
        subsid: 255,
      },
      'previous': {
        percent: 26,
        toggleSpent: 27,
        toggleTotal: 37,
        mainTotal: 38,
        subsid: 2552,
      },
      'next': {
        percent: 26,
        toggleSpent: 273,
        toggleTotal: 253,
        mainTotal: 254,
        subsid: 256,
      },
    };

    const percentId = `${additionalStr}${filterIds[ period ].percent}`;
    const toggleSpentId = `${additionalStr}${filterIds[ period ].toggleSpent}`;
    const toggleTotalId = `${additionalStr}${filterIds[ period ].toggleTotal}`;
    const mainTotalId = `${additionalStr}${filterIds[ period ].mainTotal}`;
    const subsidId = `${additionalStr}${filterIds[ period ].subsid}`;

    let percent = this.getData(percentId);
    let toggleSpent = this.getData(toggleSpentId);
    let toggleTotal = this.getData(toggleTotalId);
    let mainTotal = this.getData(mainTotalId);
    let subsid = this.getData(subsidId);
    percent = percent ? +percent.value : null;
    toggleSpent = toggleSpent ? +toggleSpent.value : null;
    toggleTotal = toggleTotal ? +toggleTotal.value : null;
    mainTotal = mainTotal ? +mainTotal.value : null;
    subsid = subsid ? +subsid.value : null;

    const series = Converter.getSeries(percent);
    const toggleValues = { spent: toggleSpent, totalfin: toggleTotal, subsid };
    const mainValues = { spent: toggleSpent, totalfin: mainTotal, percent };

    return {
      series: [ series ],
      mainValues,
      toggleValues,
    };
  }

  toDays() {
    const daysTotal = daysOfYear(new Date().getFullYear());
    const daysGone = getCurrentDayOfYear();
    const percent = getPercent(daysGone, daysTotal);
    const series = Converter.getSeries(percent);
    return {
      series: [ series ],
      mainValues: { daysTotal, daysGone },
    };
  }

  toTotalSubjectsReady(filter) {
    let period = filter.period;
    const additionalStr = 'Столбец';
    const filterIds = {
      'current': {
        percent: 282,
        subjTotal: 274,
        subjVal: 28,
      },
      'previous': {
        percent: 283,
        subjTotal: 274,
        subjVal: 2822,
      },
      'next': {
        percent: 285,
        subjTotal: 274,
        subjVal: 284,
      },
    };

    const percentId = `${additionalStr}${filterIds[ period ].percent}`;
    const subjValId = `${additionalStr}${filterIds[ period ].subjVal}`;
    const subjTotalId = `${additionalStr}${filterIds[ period ].subjTotal}`;

    let percent = this.getData(percentId);
    let subjVal = this.getData(subjValId);
    let subjTotal = this.getData(subjTotalId);
    percent = percent ? +percent.value : null;
    subjVal = subjVal ? +subjVal.value : null;
    subjTotal = subjTotal ? +subjTotal.value : null;

    const series = Converter.getSeries(percent);
    const toggleValues = { subjVal, subjTotal };

    return {
      series: [ series ],
      mainValues: toggleValues,
      toggleValues,
    };
  }

  toTotalTurnsFirst(filter) {
    let period = filter.period;
    const additionalStr = 'Столбец';
    const filterIds = {
      'current': {
        firstTurn: 31,
        secondTurn: 32,
        thirdTurn: 33,
      },
      'previous': {
        firstTurn: 31,
        secondTurn: 32,
        thirdTurn: 33,
      },
      'next': {
        firstTurn: 34,
        secondTurn: 35,
        thirdTurn: 36,
      },
    };

    const firstTurnId = `${additionalStr}${filterIds[ period ].firstTurn}`;
    const secondTurnId = `${additionalStr}${filterIds[ period ].secondTurn}`;
    const thirdTurnId = `${additionalStr}${filterIds[ period ].thirdTurn}`;

    let firstTurn = this.getData(firstTurnId);
    let secondTurn = this.getData(secondTurnId);
    let thirdTurn = this.getData(thirdTurnId);
    firstTurn = firstTurn ? +firstTurn.value : null;
    secondTurn = secondTurn ? +secondTurn.value : null;
    thirdTurn = thirdTurn ? +thirdTurn.value : null;

    const series = Converter.getSeries(firstTurn);
    const toggleValues = { firstTurn, secondTurn, thirdTurn };

    return {
      series: [ series ],
      toggleValues,
    };
  }

  toTotalTurnsSecond() {
    const secondTurn = this.initialData ? +this.initialData.value : null;

    const series = Converter.getSeries(secondTurn);

    return { series: [ series ] };
  }

  toTotalTurnsThird() {
    const thirdTurn = this.initialData ? +this.initialData.value : null;

    const series = Converter.getSeries(thirdTurn);

    return { series: [ series ] };
  }

  /**
   * text charts
   */
  toText() {
    return { mainValue: this.initialData ? this.initialData.value : null };
  }

  /**
   * Regions chart
   */
  toRegionChart() {
    let data = this.initialData;

    let series = $.map(data, (item, i) => {
      return [ [ 'x' + i, +item ] ];
    });
    return { series };
  }

  /**
   * progress step chart
   */
  toCompletionChart() {
    let data = this.initialData;

    let series = $.map(data, (item, i) => {
      return [ [ 'x' + i, +item ] ];
    });
    return { series };
  }

  toRegionSpent() {
    return {};
  }

  toObjectsBuilt(filter) {
    const period = filter.period;
    const objectType = filter.type;
    const additionalStr = 'Столбец';
    const filterIds = {
      fo: {
        current: {
          fact: '16',
          plan: '15',
        },
        previous: {
          fact: '162',
          plan: '15',
        },
        next: {
          fact: '15',
          plan: '15',
        },
      },
      subj: {
        current: {
          fact: '18',
          plan: '17',
        },
        previous: {
          fact: '182',
          plan: '17',
        },
        next: {
          fact: '17',
          plan: '17',
        },
      },
      obj: {
        current: {
          fact: '18',
          plan: '17',
        },
        previous: {
          fact: '182',
          plan: '17',
        },
        next: {
          fact: '17',
          plan: '17',
        },
      },
    };

    const factId = `${additionalStr}${filterIds[ objectType ][ period ].fact}`;
    const planId = `${additionalStr}${filterIds[ objectType ][ period ].plan}`;

    let fact = this.getData(factId);
    let plan = this.getData(planId);

    if (!(fact && +fact.value) && !(plan && +plan.value)) {
      return null;
    }
    fact = fact ? +fact.value : 0;
    plan = plan ? +plan.value : 0;
    const percent = ((fact / plan) * 100);

    return {
      fact, plan, percent,
    };
  }

  toRegionSubsid(filter) {
    const defaultData = this.initialData;
    if (!defaultData) {
      return {};
    }

    let { dynamicData } = defaultData;
    if (!dynamicData) {
      return null;
    }
    const period = filter.selects[ 0 ][ 0 ].value;
    dynamicData = dynamicData[ period ];
    dynamicData = dynamicData.filter(({ axisY }) => axisY[ 0 ].value.length !== 0);
    if (!dynamicData.length) {
      return null;
    }

    const series = [ [ 'data', ...(dynamicData.map(({ axisY }) => +axisY[ 0 ].value) || [ null ]) ] ];
    const ticks = [ [ 'x', ...(dynamicData.map(({ name }) => name) || [ null ]) ] ];

    return { series, ticks };
  }

  toBuildDynamic() {
    const defaultData = this.initialData;
    if (!defaultData) {
      return {};
    }

    let { dynamicData } = defaultData;
    dynamicData = dynamicData.filter(({ axisY }) => axisY[ 0 ].value.length !== 0);
    if (!dynamicData.length) {
      return null;
    }

    const series = [ [ 'data', ...(dynamicData.map(({ axisY }) => +axisY[ 0 ].value) || [ null ]) ] ];
    const ticks = [ [ 'x', ...(dynamicData.map(({ name }) => name) || [ null ]) ] ];

    return { series, ticks };
  }

  toRegionTotal(filter) {
    const objectType = filter.type;
    const period = (objectType === 'obj') ? 'current' : filter.period;
    const additionalStr = 'Столбец';

    const filterIds = {
      fo: {
        'current': {
          total: 12,
          federalBudget: 13,
          subjectBudget: 14,
        },
        'previous': {
          total: 472,
          federalBudget: 132,
          subjectBudget: 142,
        },
        'next': {
          total: 122,
          federalBudget: 133,
          subjectBudget: 143,
        },
      },
      subj: {
        'current': {
          total: 14,
          federalBudget: 15,
          subjectBudget: 16,
        },
        'previous': {
          total: 53,
          federalBudget: 152,
          subjectBudget: 162,
        },
        'next': {
          total: 142,
          federalBudget: 153,
          subjectBudget: 163,
        },
      },
      obj: {
        'current': {
          total: 113,
          federalBudget: 112,
          subjectBudget: 12,
        },
      },
    };

    const totalId = `${additionalStr}${filterIds[ objectType ][ period ].total}`;
    const federalBudgetId = `${additionalStr}${filterIds[ objectType ][ period ].federalBudget}`;
    const subjectBudgetId = `${additionalStr}${filterIds[ objectType ][ period ].subjectBudget}`;

    let total = this.getData(totalId);
    let federalBudget = this.getData(federalBudgetId);
    let subjectBudget = this.getData(subjectBudgetId);
    if ((!total || !+total.value)
      && (!federalBudget || !+federalBudget.value)
      && (!subjectBudget || !+subjectBudget.value)) {
      return null;
    }
    total = total ? +total.value : 0;
    federalBudget = federalBudget ? Math.round(+federalBudget.value) : 0;
    subjectBudget = subjectBudget ? Math.round(+subjectBudget.value) : 0;

    let series = [ Converter.getSeries(federalBudget, 'x1'), Converter.getSeries(subjectBudget, 'x2') ];
    series.push([ 'x3', 100 - series[ 0 ][ 1 ] - series[ 1 ][ 1 ] ]);
    const budgetValues = { total, federalBudget, subjectBudget };

    return {
      series: series,
      budgetValues,
    };
  }

  toPupilsCount() {
    const additionalStr = 'Столбец';
    const indicators = {
      amount: '22',
    };

    const amountId = `${additionalStr}${indicators.amount}`;

    let amount = this.getData(amountId);

    if ((!amount || !+amount.value)) {
      return null;
    }

    amount = amount ? +amount.value : 0;
    return { mainValue: amount };
  }

  toStudCount(filter) {
    const additionalStr = 'Столбец';
    const indicators = {
      count: {
        changeFirst: '25',
        changeSecond: '26',
        changeThird: '27',
      },
      percent: {
        changeFirst: '28',
        changeSecond: '283',
        changeThird: '282',
      },
    };

    let series = [ 'data' ];
    $.each(indicators[ filter.toggles[ 0 ] ], (key, indicator) => {
      let serieValue = this.getData(`${additionalStr}${indicator}`) || { value: 0 };
      // series.push(Converter.getSeries(serieValue.value, key));
      series.push(serieValue.value);
    });

    return {
      series: [ series ],
      dataType: filter.toggles[ 0 ],
    };
  }

  toSchoolsTotal() {
    const additionalStr = 'Столбец';
    const indicators = {
      teacher: '24',
      schools: '23',
      sports: '31',
      emergency: '30',
      percent: '29',
    };

    const percentId = `${additionalStr}${indicators.percent}`;

    let percent = this.getData(percentId);

    if (!percent || !+percent.value) {
      return null;
    }

    percent = percent ? +percent.value : 0;

    const series = [ Converter.getSeries(percent, 'x1'), Converter.getSeries(100 - percent, 'x2') ];

    return {
      series,
      percent,
    };
  }

  toObjectReadyDates() {
    const additionalStr = 'Столбец';
    const indicators = {
      first: '14',
      last: '15',
    };

    const firstId = `${additionalStr}${indicators.first}`;
    const lastId = `${additionalStr}${indicators.last}`;

    let first = this.getData(firstId);
    let last = this.getData(lastId);

    if ((!first || !first.value) && (!last || !last.value)) {
      return null;
    }

    first = first ? first.value : null;
    last = last ? last.value : null;

    return {
      first, last,
    };
  }

  toOverviewData(filter) {
    const additionalStr = 'Столбец';
    const type = filter.type;
    const indicators = {
      subj: {
        teacher: '24',
        schools: '23',
        sports: '31',
        emergency: '30',
      },
      obj: {
        capacity: '13',
        equip: '16',
      },
    };
    let overviewInfo = {};

    if (type === 'subj') {
      const teacherId = `${additionalStr}${indicators[ type ].teacher}`;
      const schoolsId = `${additionalStr}${indicators[ type ].schools}`;
      const sportsId = `${additionalStr}${indicators[ type ].sports}`;
      const emergencyId = `${additionalStr}${indicators[ type ].emergency}`;
      let teacher = this.getData(teacherId);
      let schools = this.getData(schoolsId);
      let sports = this.getData(sportsId);
      let emergency = this.getData(emergencyId);

      if (!(teacher && +teacher.value) && !(schools && +schools.value)
        && !(sports && +sports.value) && !(emergency && +emergency.value)) {
        return null;
      }

      teacher = teacher ? numToStnd(+teacher.value, 0, 2) : 0;
      schools = schools ? numToStnd(+schools.value, 0, 2) : 0;
      sports = sports ? numToStnd(+sports.value, 0, 2) : 0;
      emergency = emergency ? numToStnd(+emergency.value, 0, 2) : 0;

      overviewInfo = { teacher, schools, sports, emergency };
    } else if (type === 'obj') {
      const capacityId = `${additionalStr}${indicators[ type ].capacity}`;
      const equipId = `${additionalStr}${indicators[ type ].equip}`;
      let capacity = this.getData(capacityId);
      let equip = this.getData(equipId);

      if (!(capacity && +capacity.value) && !(equip && +equip.value)) {
        return null;
      }

      capacity = capacity ? numToStnd(+capacity.value, 0, 2) : 0;
      equip = equip ? numToStnd(+equip.value, 0, 2) : 0;

      overviewInfo = { capacity, equip };
    }

    return overviewInfo;
  }

  toRegionGovSubs({ type, period }) {
    const additionalStr = 'Столбец';
    if (type === 'obj') {
      period = 'current';
    }
    const filterIds = {
      fo: {
        'current': 1223,
        'previous': 1222,
        'next': 123,
      },
      subj: {
        'current': 1423,
        'previous': 1422,
        'next': 143,
      },
      obj: {
        'current': '114',
      },
    };
    const neededId = filterIds[ type ][ period ];
    let govSubsid = this.getData(`${additionalStr}${neededId}`);

    if (!govSubsid || !+govSubsid.value) {
      return null;
    }

    return { mainValue: +govSubsid.value };
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/src/charts.js